import styled from "styled-components";
import Icon from "~/components/shared/Icon";
import { DateFilter } from "~/components/analytics/shared/DateFilters";
import { Metrics } from "~/components/analytics/shared/type";
import ChartCard from "~/components/analytics/shared/MetricChartCards/ChartCard";

const CardContainer = styled.div`
  gap: 15px;
  padding-bottom: 20px;
  justify-content: center;

  @media (max-width: 768px) {
    flex: 1 1 auto;
    flex-direction: column;
  }

  > div {
    @media (max-width: 1320px) {
      flex: 1 0 25%;
    }
  }
`;

type Tag = {
  value: string;
  removePath: string;
};

type Props = {
  heading: string;
  chartDataUrl: string;
  chartMetricUrl: string;
  modal_heading: string;
  metrics: Array<Metrics>;
  period?: DateFilter | null;
  groupByTag?: Tag[];
};

// MetricChartCards is used to render a set of metric as cards,
// each with a non-interactive mini chart and a popover interactive chart.
// This component also handles react-based date filtering and displaying tag filters.
const MetricChartCards = ({
  heading,
  metrics,
  chartDataUrl,
  chartMetricUrl,
  modal_heading,
  period,
  groupByTag,
}: Props) => {
  const metricCardPeriod = period || "1day";

  return (
    <div>
      <h2 className="charcoal-700 pt-4 text-lg">{heading}</h2>

      {groupByTag && groupByTag.length > 0 && (
        <div className="gap1 flex flex-wrap items-center">
          <h3 className="m-0 text-sm text-gray-800">Grouped by</h3>
          {groupByTag.map((group) => (
            <a
              key={group.value}
              href={group.removePath}
              className="badge badge--outline flex max-w-full truncate pr-0"
            >
              {group.value}
              <span className="ml-1 flex items-center border-l border-gray-300">
                <Icon icon="close" className="flex-none" style={{ height: 18, width: 18 }} />
              </span>
            </a>
          ))}
        </div>
      )}

      <CardContainer className="mt-3 flex">
        {metrics.map(({ label, metric, description, chartType }) => (
          <ChartCard
            key={`${metric}-${label}`}
            metric={metric}
            label={label}
            period={metricCardPeriod}
            chartDataUrl={chartDataUrl}
            chartMetricUrl={chartMetricUrl}
            heading={modal_heading}
            description={description}
            chartType={chartType}
          />
        ))}
      </CardContainer>
    </div>
  );
};

export default MetricChartCards;
